import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { JardinComponent } from 'src/app/components/jardin/jardin.component';
import { AreasAnualesModel, FaseAnualModel, ResponseFaseAnualModel, YearsModel } from 'src/app/model/FaseAnual.model';
import { ResponseUnidadEducativaModel, UnidadEducativaModel } from 'src/app/model/Identificacion.model';
import { JardinModel } from 'src/app/model/Jardin.model';
import { apiService } from 'src/app/service/api.service';
import { PlanMejoraService } from 'src/app/service/planMejora.service';

import Swal from 'sweetalert2';
import { JardinPlanMejoraComponent } from '../../jardin-plan-mejora.component';

@Component({
  selector: 'app-fase-anual',
  templateUrl: './fase-anual.component.html',
  styleUrls: ['./fase-anual.component.css']
})
export class FaseAnualComponent implements OnInit {

  @ViewChild('divSpinner') divSpinner: ElementRef;
  @Input() simulacion: boolean;
  cargando: boolean;
  cambios: boolean;
  fechaValida: boolean;
  dataJardin = new JardinModel();
  faseAnualData = new FaseAnualModel();
  uniEducativa = new UnidadEducativaModel();
  click = false;

  constructor(
    @Inject(JardinPlanMejoraComponent) private parent: JardinPlanMejoraComponent,
    private api: apiService,
    private planMejoraService: PlanMejoraService
  ) { }

  ngOnInit(): void {
    this.click = false;
    this.cargando = true;
    this.cambios = false;
    this.fechaValida = true;
    this.cargaInicial();
  }

  change() {
    this.cambios = true;
  }

  cargaInicial() {
    this.dataJardin = this.api.dataJardin;
    this.unidadEducativa(this.dataJardin);
    this.getFaseAnual(this.dataJardin);
  }

  getPeriodoJardin(periodo) {
    let periodoString = "2021"
    if (periodo == "Alternativo") {
      periodoString = "2024-2027"
    } else {
      periodoString = "2024-2027"
    }
    return periodoString
  }

  unidadEducativa(dataJardin: JardinModel) {
    this.api.API_POST_obtenerUnidadEducatica(dataJardin.id).subscribe((response: ResponseUnidadEducativaModel) => {
      this.uniEducativa = response.payload;
    },
      (err) => {
        console.log(err)
      });
  }

  getFaseAnual(dataJardin: JardinModel) {
    this.planMejoraService.API_POST_getFaseAnual(dataJardin.id).subscribe((response: ResponseFaseAnualModel) => {
      this.faseAnualData = response.payload;
      this.cargando = false;
    },
      (err) => {
        console.log(err)
      });
  }

  guardarFaseAnual(anio: YearsModel) {

    if (!this.fechaValida) {
      Swal.fire({
        title: 'Fechas incorrectas',
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: 'OK',
      });
    } else {
      this.planMejoraService.API_POST_guardarFaseAnual(this.dataJardin.id, anio.idFaseAnualAnio, anio.orden, this.faseAnualData).subscribe((response: any) => {
        this.cambios = false;
        this.ngOnInit();
        Swal.fire({
          title: 'Realizado!',
          text: 'Guardado con éxito',
          icon: 'info',
          confirmButtonText: 'OK'
        })
      },
        (err) => {
          console.log(err)
        });
    }
  }

  guardarTodoFaseAnual() {
    if (this.click == false) {
      this.click = true;
      let anios = this.faseAnualData.anios;
      anios.forEach(anio => {
        this.planMejoraService.API_POST_guardarFaseAnual(this.dataJardin.id, anio.idFaseAnualAnio, anio.orden, this.faseAnualData).subscribe((response: any) => {
          this.cambios = false;
          this.click = false
        },
          (err) => {
            console.log(err)
          });
      });
    }
  }

  finalizarAnioFaseAnual(anioData: YearsModel) {
    this.planMejoraService.API_POST_finalizarFaseAnual(this.dataJardin.id, anioData.idFaseAnualAnio).subscribe((response: any) => {
      this.irAFinalizar();
    },
      (err) => {
        console.log(err)
      });
  }

  validarFinalizar(anioData: YearsModel) {
    let errores = [];
    Swal.fire({
      title: 'Este proceso no se puede deshacer, ¿Desea continuar?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Continuar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.planMejoraService.API_POST_guardarFaseAnual(this.dataJardin.id, anioData.idFaseAnualAnio, anioData.orden, this.faseAnualData).subscribe((response: any) => {
        },
          (err) => {
            console.log(err)
          });
        anioData.areas.forEach(area => {
          if (this.validarArea(area) != "") {
            errores.push(this.validarArea(area));
          }
        });
        if (errores.length > 0) {
          Swal.fire({
            title: 'Faltan campos',
            text: errores[0],
            icon: 'error',
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              this.ngOnInit();
            }
          });
        } else {
          this.finalizarAnioFaseAnual(anioData);
          console.log("realizado");
        }
      }

    })
  }

  validarArea(area: AreasAnualesModel): string {
    let error = ""
    let count = 0;
    area.subdimensiones.forEach(subd => {
      subd.estrategias.forEach(estrategia => {
        estrategia.acciones.forEach(accionData => {
          if (this.campoVacio(accionData.accion) && this.campoVacio(accionData.medioVerificacion) &&
            ((accionData.fechaInicioMedicion == null && accionData.fechaFinMedicion == null) ||
              (accionData.fechaInicioMedicion == undefined && accionData.fechaFinMedicion == undefined))) {
          } else if (!this.campoVacio(accionData.accion) && this.validarFechas(accionData.fechaInicioMedicion, accionData.fechaFinMedicion)
            && !this.campoVacio(accionData.medioVerificacion)) {
            count++;
          } else {
            error = "Faltan elementos por completar en la Dimensión " + area.orden + ", Subdimensión: " + subd.subdimension + ", Estrategia " + estrategia.orden;
          }
        })
      });
    });
    if (count == 0 && error == "") {
      error = "No hay Estrategias válidas en la Dimensión " + area.orden;
    }
    return error;
  }

  validarFechas(fechaInicio: Date, fechaFin: Date) {
    let fechaValida = false;

    if (fechaInicio != undefined && fechaFin != undefined && fechaInicio != null && fechaFin != null) {

      fechaInicio = new Date(fechaInicio);
      fechaFin = new Date(fechaFin);

      if (fechaFin.getTime() - fechaInicio.getTime() >= 86400000) {
        fechaValida = true;
      } else {
        fechaValida = false;
      }

    } else {
      fechaValida = false;
    }
    return fechaValida;
  }

  campoVacio(campo: string): boolean {
    return (campo == null || campo == "") ? true : false;

  }

  irA() {
    this.parent.componente="";
  }

  irAFinalizar() {
    Swal.fire({
      title: 'Fase anual finalizada con éxito',
      icon: 'success',
      confirmButtonText: 'OK'

    }).then(() => {
      this.irA();
    })
  }

  volver() {
    this.guardarTodoFaseAnual();
    this.irA();
  }

}
